import { render, staticRenderFns } from "./StripeMsgs.vue?vue&type=template&id=64fedd23&"
import script from "./StripeMsgs.vue?vue&type=script&lang=js&"
export * from "./StripeMsgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64fedd23')) {
      api.createRecord('64fedd23', component.options)
    } else {
      api.reload('64fedd23', component.options)
    }
    module.hot.accept("./StripeMsgs.vue?vue&type=template&id=64fedd23&", function () {
      api.rerender('64fedd23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/StripeMsgs.vue"
export default component.exports